export default __webpack_public_path__ + "135be2cad9afecfe5d06baa98ec81d4a.webp";